import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/**
 * CloseHub (month-end close) menu icon — a checklist inside a document, which
 * reads as "close checklist" next to the other Accounting entries.
 */
const IconCloseHub: React.FC<IconProps> = ({
  size = 21,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M4.375 2.625H16.625C17.5915 2.625 18.375 3.4085 18.375 4.375V16.625C18.375 17.5915 17.5915 18.375 16.625 18.375H4.375C3.4085 18.375 2.625 17.5915 2.625 16.625V4.375C2.625 3.4085 3.4085 2.625 4.375 2.625Z"
      stroke="currentColor"
      strokeWidth="1.35"
    />
    <path
      d="M5.95 7.35L7.35 8.75L9.8 6.3"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.95 13.3L7.35 14.7L9.8 12.25"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9 7.7H15.05"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
    />
    <path
      d="M11.9 13.65H15.05"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
    />
  </svg>
);

export default IconCloseHub;
